import { useSearchParams } from "react-router-dom";

import { DecisionEnvironment } from "src/api/types";
import { FlowVersionStatus } from "src/clients/flow-api";
import { useCapabilities } from "src/hooks/useCapabilities";
import {
  clampEnvironment,
  readableEnvironments,
} from "src/hooks/useCapabilities/decisionEnvironments";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { DecisionHistoryKeys } from "src/router/SearchParams";

export const useDecisionHistoryPaneEnv = () => {
  const { version } = useAuthoringContext();
  const [searchParams] = useSearchParams();

  const { decisionHistory } = useCapabilities();
  const readable = readableEnvironments(decisionHistory);

  // the pane is behind `canAccess`, so `readable` is never empty here
  const clamp = (wanted: DecisionEnvironment) =>
    clampEnvironment(readable, wanted) ?? DecisionEnvironment.SANDBOX;

  const defaultEnv = clamp(
    version.status === FlowVersionStatus.PUBLISHED
      ? DecisionEnvironment.LIVE
      : DecisionEnvironment.SANDBOX,
  );
  const selectedTab =
    searchParams.get(DecisionHistoryKeys.DecisionHistoryView) || defaultEnv;

  return {
    selectedEnv: clamp(
      selectedTab === DecisionEnvironment.SANDBOX
        ? DecisionEnvironment.SANDBOX
        : DecisionEnvironment.LIVE,
    ),
    defaultEnv,
    canReadLive: readable.includes(DecisionEnvironment.LIVE),
    canReadSandbox: readable.includes(DecisionEnvironment.SANDBOX),
  };
};
